(function (angular) {
    'use strict';

    angular
        .module('app.purchase')
        .controller('app.purchase.privacyPolicyModalController', [
            '$scope',
            '$http',
            privacyPolicyModalController
        ]);

    function privacyPolicyModalController($scope, $http) {
        $scope.privacyPolicyHtml = '';
        var apiUrl = environment.treatmentApiDirectUrl + 'files/public-documents/privacy-policy.html';
        $http.get(apiUrl)
             .then(function(response) {
                $scope.privacyPolicyHtml = response.data;
             });
    }

})(angular);
